

































































































































































































































































































































































































































































































































































































































































































































































































































































































































/* tslint:disable */
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import {
  ColumnsAdjustRequestData,
  ColumnSortRequestData,
  PageNumberChangeRequestData,
  PageSizeChangeRequestData,
  PaginationConfig,
  SortedColumnInfo,
  TableColumnConfig,
  TableEntry,
  TableEntrySelectingEventData,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import {
  confirmService,
  ConfirmOptions,
  ConfirmButton,
} from '@libs-uuif/shared/confirm-service';
import { CreateElement, VNode } from 'vue';
import { InfoState } from '@/core';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import uuifComponent from '@/shared/uuifComponent';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import {
  SwContentToolbar,
  SwContentToolbarExpand,
} from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwCountryStateComponent } from '@/shared/country-state-component';
import searchedUserService from '@/shared/searched-user.service';
import _ from 'lodash';
import * as decode from 'jwt-decode';
import { required, email, helpers } from 'vuelidate/lib/validators';
import RegexValidators from '@/shared/regex-validators';
import AddServices from './addServices.component.vue';
import DeclineQuoteModal from '../components/declineQuoteModal.vue';
import RequestChangeModal from '../components/requestChangeModal.vue';
import { currentUserKey } from '@/shared/msw-constants';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import EmailQuoteModal from "../components/emailQuoteModal.vue";
// import { ToggleOptions  } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle/types';
import { SwGroupToggle, ToggleOptions } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import ChangeBillingAddress from '@/shared/changeBillingAddress/changeBillingAddress.component.vue';
import BillingInfo from '@/shared/billing-info/BillingInfo.vue';

const cssPrefix = 'snb-show-quote-details';
const postalCode = helpers.regex('postalCode', new RegExp(RegexValidators.postalCode));
const phone = helpers.regex('phone', new RegExp(RegexValidators.phoneNo));

@Component({
  components: {
    ...uuifComponent,
    DeclineQuoteModal,
    RequestChangeModal,
    MswAppTitle,
    SwDropMenu,
    SwIcon,
    SwIconButton,
    SwGroupToggle,
    DropdownLight,
    SwCheckbox,
    SwExpandableTextfield,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwSelect,
    SwCountryStateComponent,
    AddServices,
    EmailQuoteModal,
    ChangeBillingAddress,
    BillingInfo,
  },
  validations: {
    additionalInputs: {
      resellerPhoneNO: { phone },
      check1: { required },
      poNumber: { required },
      poContactPhone: { phone },
      poContactEmail: { email },
      poContactCompanyName: { required },
      poContactAddress1: { required },
      poContactcity: { required },
      poContactZipcode: { postalCode },
    },
  },
})
export default class Showquotedetails extends SwExtendedVue {
  /* tslint:disable */
  cssPrefix = cssPrefix;

  @Prop()
  quoteIdInput: string | (string | null)[];

  isDeclineModal: boolean = false;
  roles: any[] = [];
  quoteFilter: any;
  quoteHistoryData: any;
  totalRecords: number = 0;
  rowData: any;
  columnDefs: any[];
  spinner: boolean = false;
  enableSearch: boolean = false;
  searchKey = '';
  appliedFilter = [];
  filtersConfig = [];
  filterHoverValues: boolean = false;
  columnWidth: number;
  snbuser: string = '';
  quoteHistoryColumnsConfig: any;
  // selectedOption: any = '';
  purchaseModes: any[] = [];
  options: ConfirmOptions;
  buttons: ConfirmButton[];

  // Martian updates
  menuOpened: boolean = false;
  selectedMenuItem: string = '';
  searchValue: any = '';
  search: any = '';
  menuItems: DropMenuItem[] = [];
  textExpanded: boolean = false;
  apiResponse: any = [];
  isParent = true;
  deleteReason: string = '';
  showDeleteReasonModal: boolean = false;
  groupTextValue: string = '';
  previousYearVal: string = '';
  groupToggleTextOptions: ToggleOptions = [
    {
      id: '1',
      text: this.$t('quote.oneYear')
      .toString(),
    },
    {
      id: '2',
      text: this.$t('quote.twoYear')
      .toString(),
    },
    {
      id: '3',
      text: this.$t('quote.threeYear')
      .toString(),
    },
  ];
  disableYear: boolean = false;
  // TABLE STUFF STARTS
  filterApplied: boolean = false;
  searchInputText = '';
  isExpandSearchFilter: boolean = false;
  filteredTableData: TableEntry[] = [];
  tableData: TableEntry[] = [];
  tableColConfig: TableColumnConfig[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  isLoadingPartialDataset: boolean = false;
  partialDatasetPaginationConfig: PaginationConfig = {
    pageNumber: 1,
    pageSize: 50,
    datasetOffset: 0,
    datasetTotal: 0,
  };
  selectedUserId: any = '';
  userDetailModal: boolean = false;
  deleteSubscriptionName: any = '';
  deleteSubscriptionID: any = '';
  subscriptionEndDate: any = '';
  cancelDate: any = '';
  deleteRecord: {
    subscriptionEndDate: any;
    cancelDate: any;
    comments: string;
  } = {
    subscriptionEndDate: '',
    cancelDate: '',
    comments: '',
  };
  showEditBillingSection: boolean = false;
  dateValue: string = '';
  quoteID: string | (string | null)[];
  hideQuoteData: boolean;
  quoteData: any = {};
  quoteAddress: any = {};
  purchaseModesDetails: any = [];
  selectedPM: any = '';
  selectedPMDisp: any = '';
  quoteItems: any;
  additionalInputs: any = {
    poNumber: null,
    poContactEmail: null,
    poContactName: null,
    poContactPhone: null,
    check1: null,
    check2: null,
    resellerContactName: null,
    resellerName: null,
    resellerPhoneNO: null,
    poContactCompanyName: null,
    poContactAddress1: null,
    poContactAddress2: null,
    poContactcity: null,
    poContactZipcode: null,
    poContactProvince: null,
    poContactState: null,
    poContactCountry: null,
  };
  noQuoteErrorMsg: any;
  isQuoteExpired: any = '';
  isRowSelected: boolean = false;
  selectedRows: any[] = [];
  isRisOrder: any = '';
  bisdynamicnode: boolean = false;
  isPending: boolean = false;
  isPopUp: boolean = false;
  isdirectAccess: boolean = false;
  isCustomer: boolean = false;
  isPartnerOrSales: boolean = false;
  isOrderTypeRM: boolean = false;
  hideAddService: boolean = false;
  saveAddressForFuture: boolean = true;
  isOpenServicesDialog: boolean = false;
  addServiceType: string = '';
  enableTooltip: boolean = true;
  isRequestChangeModal: boolean = false;
  isEmailModal: boolean = false;
  emailAddress: any = '';
  modalQuoteId: any = '';

  @Watch('searchInputText')
  searchInputTextChanged(val: any) {
    if (val === '') {
      this.filterApplied = false;
    }
  }

  get queryParam() {
    return this.$router.currentRoute.query;
  }

  get isPageLoading(): boolean {
    return this.$store.getters.loading;
  }

  adjustedColumns: ColumnsAdjustRequestData = {};

  getWidthConfig() {
    const widthConfig = {
      label: 100,
      field: 100,
    };
    return widthConfig;
  }

  onValueChanges(value: any) {
    if (value.label === 'country') {
      this.quoteAddress.country = value.country;
      // this.isVatRequired = value.isVatRequired ? value.isVatRequired : false;
    } else if (value.label === 'state') {
      this.quoteAddress.state = value.state;
    } else {
      this.quoteAddress.province = value.province;
    }
    // this.setAddressValidation(value);
  }

  get getPurchaseModes() {
    const purchaseModes = this.purchaseModesDetails;
    let options = [];
    if (purchaseModes && purchaseModes.length > 0) {
      options = purchaseModes.map((el: any) => {
        return {
          id: el.orderOptionId,
          value: el.orderOptionId,
          label: el.orderName,
        };
      });
    }
    return options;
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    const template = {
      secaasSubscriptionId: '',
      invoiceId: '',
      pageSize: this.partialDatasetPaginationConfig.pageSize,
      pageNo: this.partialDatasetPaginationConfig.pageNumber,
      sortColumn: data.colKey.toUpperCase(),
      sortOrder: '',
    };
    const index = this.sortedColumns.findIndex((col) => col.colKey === data.colKey);
    if (index < 0) {
      if (data.cancel) {
        return;
      }
      this.applySort({ ...template, sortOrder: 'desc' }).then((response: any) => {
        this.sortedColumns.splice(0);
        this.sortedColumns.push({
          colKey: data.colKey,
          ascending: !!data.ascending,
        });
        this.$store.commit('stopLoading');
        this.setApiResponse(response);
      });
    } else {
      if (data.cancel) {
        this.sortedColumns.splice(index, 1);
        return;
      }
      // this is sort using spi
      this.applySort({ ...template, sortOrder: 'asc' }).then((response: any) => {
        this.sortedColumns[index].ascending = !!data.ascending;
        this.$store.commit('stopLoading');
        this.setApiResponse(response);
      });
    }
  }

  async applySort(template: any) {
    this.$store.commit('startLoading');
    const data = await this.$store.dispatch(
      'SnbQuotesStoreModule/getAllQuoteHistoryData',
      template,
    );
    return data;
  }

  async makeTableData(quoteData?: any) {
    const tableData = this.$store.getters['SnbQuotesStoreModule/getQuoteData'].map(
      (el: any, index: any) => {
        // const tableData = this.$store.getters['SnbQuotesStoreModule/getQuoteHistoryData'].map((el: any, index: any) => {
        return {
          ...el,
          _key: index,
          autoRenew: el.autoRenew === 'YES' ? true : false,
        };
      },
    );
    this.tableData = tableData;
  }

  makeTableConfig() {
    const makeElipsis = (item: string, size = 20) => {
      if (item.length > size) {
        return `${item.slice(0, size)}...`;
      }
      return item;
    };
    const tableConfig: TableColumnConfig[] = [
      {
        key: 'selection',
        type: 'selection',
      },
      {
        key: 'index',
        type: 'index',
        width: 50,
      },
      {
        key: 'ssipnDesc',
        dataKey: 'ssipnDesc',
        title: this.$t('common.description')
        .toString(),
        sorter: true,
        width: 300,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: data.entry.ssipnDesc,
              }}
            >
              <a style='font-weight: bold' onClick={() => this.handleViewClick()}>
                {makeElipsis(data.entry.ssipnDesc, 25)}
              </a>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'quantity',
        dataKey: 'quantity',
        title: this.$t('quote.quantity')
        .toString(),
        sorter: true,
        // width: 90,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: data.entry.quantity,
              }}
            >
              {makeElipsis(data.entry.quantity, 25)}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'nodeCount',
        dataKey: 'nodeCount',
        title: this.$t('quote.userCount')
        .toString(),
        sorter: true,
        // width: 90,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `User Count: ${data.entry.nodeCountnt}`,
              }}
            >
              {data.entry.nodeCount}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: this.$t('quote.serialNo')
        .toString(),
        sorter: true,
        // width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `Serial Number: ${data.entry.serialNumber}`,
              }}
            >
              {data.entry.serialNumber}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'friendlyName',
        dataKey: 'friendlyName',
        title: this.$t('quote.friendlyName')
        .toString(),
        sorter: true,
        // width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;text-align:center'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `Friendly Name: ${data.entry.friendlyName}`,
              }}
            >
              {data.entry.friendlyName || '-'}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'ssipn',
        dataKey: 'ssipn',
        title: this.$t('quote.sku')
        .toString(),
        sorter: true,
        // width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `SKU: ${data.entry.ssipn}`,
              }}
            >
              {data.entry.ssipn}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'startDate',
        dataKey: 'startDate',
        title: this.$t('quote.startDate')
        .toString(),
        sorter: true,
        // width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `Start Date: ${data.entry.startDate}`,
              }}
            >
              {data.entry.startDate}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'endDate',
        dataKey: 'endDate',
        title:  this.$t('bulkActivationStatus.endDate')
        .toString(),
        sorter: true,
        // width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `End Date: ${data.entry.endDate}`,
              }}
            >
              {data.entry.endDate}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'unitPrice',
        dataKey: 'unitPrice',
        title: this.$t('quote.unitPrice')
        .toString(),
        sorter: true,
        // width: 120,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `Unit Price: ${data.entry.unitPrice}`,
              }}
            >
              {data.entry.unitPrice}
            </div>
          ) as VNode;
        },
      },
      {
        key: 'autoRenew',
        dataKey: 'autoRenew',
        title: this.$t('quote.autoRenew')
        .toString(),
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div style='width: 100%;text-align:center'>
              <SwCheckbox
                name='checkbox'
                props-value={data.entry.autoRenew}
                props-checked={data.entry.autoRenew}
                on-change={() => {
                  data.entry.autoRenew = !data.entry.autoRenew;
                  const payload = {
                    equoteItemID: data.entry.EquoteItemId,
                    autoRenew: data.entry.autoRenew ? 'YES' : 'NO',
                  };
                  this.$store
                    .dispatch('SnbQuotesStoreModule/quoteAutoRenew', payload)
                    .then((resp) => {
                      this.$store.commit('stopLoading');
                      if (resp.operationStatus === 'OK') {
                        const message: InfoState = {
                          infoType: 'success',
                          infoMsg: resp.msgDesc,
                        };
                        this.$store.commit('displayMessage', message);
                        this.getQuoteDetails();
                      } else {
                        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
                        this.$store.commit('displayMessage', message);
                      }
                    });
                }}
              ></SwCheckbox>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'remove',
        dataKey: 'remove',
        title: this.$t('quote.remove')
        .toString(),
        sorter: true,
        width: 75,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              style='width: 100%;text-align:center'
              v-tooltip={{
                placement: 'top',
                persistent: false,
                compact: true,
                content: `Remove item`,
              }}
            >
              {!this.isQuoteExpired ? (
                <SwIcon
                  name='trash'
                  style='cursor:pointer'
                  props-size='14'
                  nativeOn-click={() => {
                    this.removeItem(data.entry);
                  }}
                ></SwIcon>
              ) : (
                '-'
              )}
            </div>
          ) as VNode;
        },
      },
    ];
    // this.tableColConfig = tableConfig.filter((el: any) => el.key !== 'ssipnDesc' && el.key !== 'quantity');
    this.tableColConfig = tableConfig;
  }

  handleSearchFilter() {
    if (this.searchInputText.trim() === '') {
      return;
    }
    this.filteredTableData = _.filter(this.tableData, (o: any) => {
      let flag = false;
      if (
        o.ssipnDesc.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.quantity.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.ssipn.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1 ||
        o.unitPrice.toLowerCase().indexOf(this.searchInputText.toLowerCase()) > -1
      ) {
        flag = true;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    this.filterApplied = true;
  }

  onEntrySelecting(data: TableEntrySelectingEventData) {
    const selectedKey: any = data.entryKey;
    if (data.selecting) {
      this.selectedRows.push(selectedKey);
    } else {
      if (this.selectedRows.length && this.selectedRows.length > 0) {
        const selectedEntryIndex = this.selectedRows.indexOf(selectedKey);
        this.selectedRows.splice(selectedEntryIndex, 1);
      }
    }
    this.isRowSelected = this.selectedRows && this.selectedRows.length > 0 ? true : false;
  }

  get partialDatasetData(): TableEntry[] {
    if (this.isLoadingPartialDataset) {
      return [];
    }
    return this.tableData.slice(
      this.partialDatasetPaginationConfig.datasetOffset,
      this.partialDatasetPaginationConfig.datasetOffset! +
        this.partialDatasetPaginationConfig.pageSize,
    );
  }

  async openUserDetails(data: any) {
    this.selectedUserId = await data.accountNumber;
    this.userDetailModal = true;
  }

  handleViewClick() {}

  reloadData() {
    this.getQuoteHistory();
    // this.fetchAllData();
  }

  toLoad: number = 50;

  onChangePartialDatasetPageNumber(data: PageNumberChangeRequestData) {
    this.partialDatasetPaginationConfig.pageNumber = data.pageNumber;
    this.partialDatasetPaginationConfig.datasetOffset =
      Math.max(this.partialDatasetPaginationConfig.pageNumber - 1, 0) *
      this.partialDatasetPaginationConfig.pageSize;
    this.isLoadingPartialDataset = true;
    this.isLoadingPartialDataset = false;
  }

  onChangePartialDatasetPageSize(data: PageSizeChangeRequestData) {
    this.partialDatasetPaginationConfig.pageSize = data.pageSize;
    /** we also need to make sure the page number is within the reasonable range */
    this.partialDatasetPaginationConfig.pageNumber = Math.min(
      this.partialDatasetPaginationConfig.pageNumber,
      Math.ceil(
        this.partialDatasetPaginationConfig.datasetTotal! /
          this.partialDatasetPaginationConfig.pageSize,
      ),
    );
    this.partialDatasetPaginationConfig.datasetOffset =
      Math.max(this.partialDatasetPaginationConfig.pageNumber - 1, 0) *
      this.partialDatasetPaginationConfig.pageSize;
    this.isLoadingPartialDataset = false;
  }

  // showConfirmDialog(message: string) {
  //   const buttonsTransferConfirm: ConfirmButton[] = [
  //     { key: 'cancel', name: 'Cancel' },
  //     { key: 'save', name: 'Confirm', isDefault: true },
  //   ];
  //   const optionsTransferConfirm: ConfirmOptions = {
  //     message,
  //     status: 'high',
  //     title: 'Warning',
  //     buttons: buttonsTransferConfirm,
  //   };
  //   return confirmService.confirm(optionsTransferConfirm);
  // }

  handleClear(): void {
    this.partialDatasetPaginationConfig.pageNumber = 1;
    this.search = '';
    this.getQuoteHistory();
  }

  // async filterSearch() {
  //   this.partialDatasetPaginationConfig.pageNumber = 1;
  //   const conditions = {
  //     filterName: this.decideFilterName(this.selectedMenuItem),
  //     filterValue: this.searchValue.trim(),
  //     filterCondition: '',
  //   };
  //   this.isLoadingPartialDataset = true;
  //   let items: any = await getDataFromIdb('secaasSubscriptions');
  //   const searchResults: any = items.filter((el: any) => {
  //     // @ts-ignore
  //     return el[this.decideFilterName(this.selectedMenuItem)]
  //     .toLowerCase()
  //     .includes(this.searchValue.toLowerCase()
  //     .trim());
  //   });
  //   items = [];
  //   const updatedData = searchResults.map((el: any, index: any) => {
  //     return {
  //       ...el,
  //       _key: index,
  //     };
  //   });
  //   if (searchResults.length > 0) {
  //     this.setTotalDataSize(searchResults.length);
  //     this.tableData = updatedData.slice(0, searchResults > 50 ? 50 : searchResults.length);
  //     this.isLoadingPartialDataset = false;
  //   }

  //   if (searchResults.length === 0) {
  //     this.getQuoteHistory('', conditions);
  //   }
  // }

  onClickMenuButton(): void {
    this.menuOpened = !this.menuOpened;
  }

  onSelectItem(itemId: string): void {
    this.selectedMenuItem = itemId;
    this.onClickMenuButton();
    setTimeout(() => {
      (document
        .getElementsByClassName('sw-textfield__wrapper__input')
        .namedItem(itemId) as HTMLElement).focus();
    }, 500);
  }

  setTotalDataSize(size: any) {
    this.partialDatasetPaginationConfig = {
      pageNumber: 1,
      datasetTotal: size,
      pageSize: 50,
    };
  }

  makeMenuItems(): void {
    const menuItems: any = [];
    menuItems.push({
      id: 'Oracle order number',
      content: this.$t('quote.oracleOrdNum')
      .toString(),
    });
    this.tableColConfig.forEach((el: any) => {
      if (el.key !== 'action') {
        menuItems.push({
          id: el.title,
          content: el.title,
        });
      }
    });
    this.menuItems = menuItems;
  }

  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    // this.$store.commit('displayMessage', message);
    this.$store.commit('enqueueMessage', message);
  }

  // fetchAllData() {
  //   getCompleteSubscriptionList().then((response: any) => {
  //     saveDataToIdb('secaasSubscriptions', response.content.secaasSubscriptionList);
  //   });
  // }

  closeBillingInfoDialog(status: boolean) {
    if (status) {
      this.showEditBillingSection = false;
      this.getQuoteDetails();
    }
  }

  editAddress() {
    this.showEditBillingSection = true;
  }

  mounted() {
    const user: any = localStorage.getItem(currentUserKey);
    this.roles = JSON.parse(user).roles;
    if (this.quoteIdInput) {
      this.quoteID = this.quoteIdInput;
      this.hideQuoteData = false;
      this.isPopUp = true;
      this.load();
    } else {
      this.isPopUp = false;
      this.isdirectAccess = true;
      if (this.queryParam?.mode === 'REDIRECTQUOTE') {
        //
      } else if (this.queryParam?.selectedQuoteId) {
        this.quoteID = this.queryParam?.selectedQuoteId;
        this.hideQuoteData = false;
        this.load();
      }
    }
  }

  load() {
    this.getQuoteDetails();
  }

  getQuoteDetails(addSerialCol?: number) {
    this.spinner = true;
    if (this.quoteID) {
      const payload = {
        quoteID: this.quoteID,
      };
      this.$store.dispatch('SnbQuotesStoreModule/getQuoteForDetails', payload).then((res) => {
        this.$store.commit('stopLoading');
        this.quoteData = res?.content;
        this.quoteAddress = res?.content?.quoteAddress;
        this.purchaseModesDetails = res?.content?.getOrderOption?.length > 0 ? res?.content?.getOrderOption : [];
        if (this.purchaseModesDetails?.length > 0) {
          this.purchaseModes = this.purchaseModesDetails.map((modes: any) => {
            return modes.orderName;
          });
        }
        this.selectedPM = res?.content?.orderOptionID == '0' ? '3' : res.content.orderOptionID;
        this.selectedPMDisp = this.purchaseModesDetails?.length > 0
            ? this.purchaseModesDetails.find((x: any) => x.orderOptionId === this.selectedPM).orderName
            : '';
        res?.content?.quoteItems
          ? (this.quoteItems = res.content.quoteItems)
          : (this.quoteItems = []);
        this.$store.dispatch('SnbQuotesStoreModule/setQuoteForDetails', this.quoteItems);
        this.noQuoteErrorMsg = res.content.quoteItems[0].errMsg;
        this.additionalInputs.poNumber = res.content.InVoiceNumber;
        this.additionalInputs.poContactEmail = res.content.POContactEmail;
        this.additionalInputs.poContactName = res.content.POContactName;
        this.additionalInputs.poContactPhone = res.content.POContactPhone;
        this.additionalInputs.check1 = res.content.checkNumber1;
        this.additionalInputs.check2 = res.content.checkNumber2;
        this.additionalInputs.resellerContactName = res.content.resellerContact;
        this.additionalInputs.resellerName = res.content.resellerName;
        this.additionalInputs.resellerPhoneNO = res.content.resellerPhone;

        this.additionalInputs.poContactCompanyName = res.content.poContactCompanyName || '';
        this.additionalInputs.poContactAddress1 = res.content.poContactAddress1 || '';
        this.additionalInputs.poContactAddress2 = res.content.poContactddress2 || '';
        this.additionalInputs.poContactCity = res.content.poContactcity || '';
        this.additionalInputs.poContactZipcode = res.content.poContactZipcode || '';

        this.additionalInputs.poContactProvince = this.quoteAddress.poContactProvince;
        this.additionalInputs.poContactState = this.quoteAddress.poContactState;
        this.additionalInputs.poContactCountry = this.quoteAddress.poContactCountry;

        this.isQuoteExpired = res.content.isQuoteExpired;
        this.isRisOrder = res.content.isRisOrder;
        this.bisdynamicnode = res.content.isDynamicNodeCount;
        if (this.quoteData.quoteStatus != undefined) {
          if (
            this.quoteData.quoteStatus.toLowerCase() == 'pending.' ||
            this.quoteData.quoteStatus.toLowerCase() == 'request change'
          ) {
            this.isPending = true;
          } else {
            this.isPending = false;
          }
        }
        let prevSelectedYear: string = '0';
        let toggleSelectedYr: string = '0';
        this.quoteData.quoteItems.forEach((element: any) => {
          if( prevSelectedYear === '0' ){
            prevSelectedYear = element.selectedYear;
            toggleSelectedYr = element.selectedYear;
            if (prevSelectedYear === '-1') this.disableYear = true;
          } else {
            if (prevSelectedYear !== element.selectedYear) {
              if (element.selectedYear > '0') toggleSelectedYr = element.selectedYear;
              else if (prevSelectedYear > '0') toggleSelectedYr = prevSelectedYear;
              this.disableYear = false;
              return true;
            }
          }
        });
        this.groupTextValue = toggleSelectedYr === undefined ? '' : toggleSelectedYr;
        this.previousYearVal = this.groupTextValue;
        const user: any = localStorage.getItem(currentUserKey);
        // let decodedtok: any = decode(this.$store.getters.getSearchedSandboxToken);
        let decodedtok: any = decode(JSON.parse(user).token);
        this.isPartnerOrSales =
          ((this.roles.indexOf('Partner') > -1 || this.roles.indexOf('partnernew') > -1) &&
            decodedtok.self == '1') ||
          (decodedtok.self != undefined && decodedtok.self == '0');
        if (!this.isPartnerOrSales) this.isCustomer = this.roles.indexOf('CUSTOMER') > -1;
        if (
          this.quoteData.orderType == 'RM' &&
          this.isPending &&
          !this.isQuoteExpired &&
          this.isPartnerOrSales
        ) {
          //remove this.quoteData.orderType == 'RM'
          this.isOrderTypeRM = true;
        } else {
          this.isOrderTypeRM = false;
        }
        if (res.content.ischannelApproved) {
          if (this.quoteData.orderType == 'RM') {
            this.selectedPM = '7';
          } else {
            this.selectedPM = '4';
            this.selectedPMDisp = 'PO';
          }
        }
        let userName = decodedtok.userName;
        for (let quote of this.quoteData.quoteItems) {
          if (userName === quote.serialNumber.toLowerCase()) {
            this.hideAddService = true;
          }
        }
        if (!this.isPopUp) {
          // this.colDefs[7].hide = true;
          // this.colDefs[8].hide = true;
        }
        this.makeTableConfig();
        this.makeTableData();
      });

        if (this.quoteData.orderType == 'RM' ){ //remove and add self condition
            this.isPopUp= true;
        }

    }else{
      this.isPopUp = false;
    }
  }

  confirmAdd(msg: string) {
    this.buttons = [
      {
        key: 'cancel',
        name: this.$t('common.cancel')
        .toString(),
        isDefault: true,
      },
      {
        key: 'yes',
        name: this.$t('profile.yes')
        .toString(),
      },
    ];
    this.options = {
      status: 'high',
      title: this.$t('checkout.confirmation')
      .toString(),
      message: msg,
      buttons: this.buttons,
    };
  }
  updateYear() {
    if (this.groupTextValue === '-1') this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Unable to perform the operation!' });
    else {
      let itemIds: any = [];
      this.quoteData.quoteItems.forEach((item: any) => {
        itemIds.push(item.EquoteItemId);
      });
      const payload = {
        equoteId: this.quoteID,
        ssipnYear: this.groupTextValue,
        equoteItemIds: itemIds,
      };
      this.$store.dispatch('SnbQuotesStoreModule/updateYearInDetailPage', payload)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.msgCode === 'MSWAPP:UPDATEQUOTEITEM' && res.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: 'Updated Successfully!' });
          this.load();
        } else {
          this.groupTextValue = this.previousYearVal;
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        }
      });
    }
  }
  onOptionSelect() {}

  removeItem(entry: any) {
    let msg = this.$t('quote.cnfrmQuoteDel')
    .toString();
    this.confirmAdd(msg);
    confirmService.confirm(this.options).then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        const payload = {
          equoteId: this.quoteID,
          equoteItemIds: entry.EquoteItemId,
        };
        this.$store
          .dispatch('SnbQuotesStoreModule/deleteQuoteItem', payload)
          .then((resp: any) => {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
              this.getQuoteDetails();
            } else {
              const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
            }
          });
      } else {
      }
    });
  }

  setApiResponse(resp: any) {
    this.$store.dispatch(
      'SnbQuotesStoreModule/setQuoteHistoryData',
      resp.content.quoteDetails,
    );
    this.$store.dispatch(
      'SnbQuotesStoreModule/setQuoteHistoryDataTotalRecords',
      resp.content.quoteDetails.length,
    );
    this.makeTableConfig();
    this.makeMenuItems();
    this.makeTableData();
    this.partialDatasetPaginationConfig.datasetTotal = this.$store.getters[
      'SnbQuotesStoreModule/getQuoteHistoryDataTotalRecords'
    ];
  }

  getQuoteHistory(quoteHistory = '', filterConditions = {}) {
    this.isLoadingPartialDataset = true;
    const template = {
      quoteHistory: quoteHistory,
      invoiceId: '',
      pageSize: this.partialDatasetPaginationConfig.pageSize,
      pageNo: this.partialDatasetPaginationConfig.pageNumber,
      ...filterConditions,
    };
    this.$store
      .dispatch('SnbQuotesStoreModule/getQuoteHistory')
      .then((resp: any) => {
        this.quoteFilter = resp.content.quoteDuration;
        if (resp.msgCode == 'MSWAPP:SUCCESS') {
          this.setApiResponse(resp);
        } else {
          this.rowData = [];
        }
        this.$store.commit('stopLoading');
      })
      .catch((error: any) => {
        // snb-revisit :: remove next line
        console.warn('SNBQuoteHistory :: ', error);
      });
  }

  exportExcel() {
    const excelList: any = [];
    let column: any[] = [
      'SERIAL NUMBER',
      'FRIENDLY NAME',
      'SSIPN DESC',
      'START DATE',
      'END DATE',
      'SSIPN',
      'UNIT PRINCE',
      'QUANTITY',
      'NODE COUNT',
      'AUTO RENEW',
    ];
    excelList.push(column);
    column = [];
    for (const el of this.tableData) {
      column.push(el.serialNumber);
      column.push(el.friendlyName);
      column.push(el.ssipnDesc);
      column.push(el.startDate);
      column.push(el.endDate);
      column.push(el.ssipn);
      column.push(el.unitPrice);
      column.push(el.quantity);
      column.push(el.nodeCount);
      const autoRenew = el.autoRenew ? 'YES' : 'NO';
      column.push(autoRenew);
      excelList.push(column);
      column = [];
    }
    const csvContent = ''.concat(excelList.map((e: any) => e.join(',')).join('\n'));
    const blob = new Blob([csvContent]);
    const link: any = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `QuoteDetail.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
  }

  createNewQuote() {
    if (this.isRowSelected) {
      if (this.selectedRows.length == this.quoteItems.length) {
        const message: InfoState = { infoType: 'failed', infoMsg: this.$t('quote.fewItemsMsg').toString() };
        this.$store.commit('displayMessage', message);
      }
      let equoteItemIds: any = [];
      this.selectedRows.forEach((quoteId: any) => {
        equoteItemIds.push(this.tableData[quoteId].EquoteItemId);
      });
      const payload = {
        equoteId: this.quoteID,
        equoteItemIds: equoteItemIds,
      };
      this.$store
        .dispatch('SnbQuotesStoreModule/createNewQuote', payload)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
            this.getQuoteDetails();
          } else {
            const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          }
        });
    } else {
      const message: InfoState = { infoType: 'failed', infoMsg: this.$t('quote.minOneItemMsg').toString() };
      this.$store.commit('displayMessage', message);
    }
  }

  checkValidations() {
    // if (this.quoteIdInput != undefined) {
    //     this.selectedPM = '7';
    // }
    return (
      (this.selectedPM == '4' &&
        (this.additionalInputs.poNumber == '' ||
          this.additionalInputs.poContactPhone == '' ||
          this.additionalInputs.poContactEmail == '')) ||
      (this.selectedPM == '5' && this.additionalInputs.check1 == '') ||
      (this.selectedPM == '2' && this.additionalInputs.resellerPhoneNO == '')
    );
  }

  validateBeforeQuoteUpdate() {
    if (this.checkValidations()) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.updateQuote();
      }
    } else {
      this.updateQuote();
    }
  }

  updateQuote() {
    let newInfo = {
      quoteId: this.quoteID,
      invoiceNo: this.additionalInputs.poNumber,
      poContactName: this.additionalInputs.poContactName,
      poContactPhone: this.additionalInputs.poContactPhone,
      poContactEmail: this.additionalInputs.poContactEmail,
      resellerName: this.additionalInputs.resellerName,
      resellerContactName: this.additionalInputs.resellerContactName,
      resellerPhoneNO: this.additionalInputs.resellerPhoneNO,
      check1: this.additionalInputs.check1,
      check2: this.additionalInputs.check2,
      desc: this.quoteItems[0].ssipnDesc,
      fullName: this.quoteAddress.fullName,
      address1: this.quoteAddress.addressLine1,
      address2: this.quoteAddress.addressLine2,
      city: this.quoteAddress.city,
      state: this.quoteAddress.state ? this.quoteAddress.state : '',
      zipcode: this.quoteAddress.zipCode,
      emailAddress: this.quoteAddress.emailAddress,
      phone: this.quoteAddress.phoneNumber,
      purchaseOptionId: this.selectedPM,
      province: this.quoteAddress.province ? this.quoteAddress.province : '',
      country: this.quoteAddress.country,
      isSaveAddress: this.saveAddressForFuture,
      poContactCompany: this.additionalInputs.poContactCompany,
      poContactAddress1: this.additionalInputs.poContactAddress1,
      poContactAddress2: this.additionalInputs.poContactAddress2,
      poContactCity: this.additionalInputs.city,
      poContactPostalCode: this.additionalInputs.poContactPostalCode,
      poContactProvince: this.additionalInputs.poContactProvince,
      poContactState: this.additionalInputs.poContactState,
      poContactCountry: this.additionalInputs.poContactCountry,
    };
    this.emailAddress = this.quoteAddress.emailAddress;
    this.modalQuoteId = this.quoteID;
    this.$store
      .dispatch('SnbQuotesStoreModule/updateQuoteDetail', newInfo)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          this.getQuoteDetails();
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      });
  }

  addServices(type: string) {
    this.addServiceType = type;
  }

  clearServiceType() {
    this.addServiceType = '';
  }
  closeServicesDialog() {
    this.isOpenServicesDialog = false;
    this.load();
  }

  addServicesRnwlMgrDialog() {
    this.isOpenServicesDialog = true;
  }

  removeQuotes() {
    if (this.isRowSelected) {
      let msg =
        this.selectedRows && this.selectedRows.length > 1
          ? this.$t('quote.removeItemConfMsg')
          .toString()
          : this.$t('quote.removeItemConfMsg')
          .toString();
      this.confirmAdd(msg);
      confirmService.confirm(this.options).then((key) => {
        if (key === 'yes') {
          this.$store.commit('startLoading');
          let equoteItemIds: any = [];
          this.selectedRows.forEach((quoteId: any) => {
            equoteItemIds.push(this.tableData[quoteId].EquoteItemId);
          });
          const payload = {
            equoteId: this.quoteID,
            equoteItemIds: equoteItemIds.toString(),
          };
          this.$store
            .dispatch('SnbQuotesStoreModule/deleteQuoteItem', payload)
            .then((resp: any) => {
              this.$store.commit('stopLoading');
              if (resp.operationStatus === 'OK') {
                const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
                this.$store.commit('displayMessage', message);
                this.getQuoteDetails();
              } else {
                const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
                this.$store.commit('displayMessage', message);
              }
            });
        } else {
        }
      });
    }
  }

  navigateToPrintQuote() {
    // let userName = this.$route.query.snbuser;
    if (this.quoteID) {
      const url = `${window.location.origin}/workspace/m/quoteReceipt?selectedQuoteId=${this.quoteID}`;
      window.open(url, '_blank');
    }
  }

  emailQuote(arg:any) {
    this.isEmailModal = arg === '0' ? false : true;
    if (this.isEmailModal) {
      this.emailAddress = this.quoteAddress.emailAddress;
      this.modalQuoteId = this.quoteID;
    }
  }

  declineQuote() {
    this.isDeclineModal = !this.isDeclineModal;
  }
  requestChange() {
    this.isRequestChangeModal = !this.isRequestChangeModal;
  }
  isShowCheckout() {
    if (this.quoteData.orderType != undefined) {
      if (this.quoteData.orderType === 'RM' && this.isPending ) {
        return true;
      }
      else if (!this.quoteData.isQuoteExpired) {
        return true;
      }
      else{
        return false
      }
    }
    else {
        if(this.quoteData.orderType == 'RM' && (this.quoteData.quoteStatus.toLowerCase() == 'pending.' || this.quoteData.quoteStatus.toLowerCase() == "request change")) {
            return true;
        }
        else if(!this.quoteData.isQuoteExpired){
            return true;
        }
        else
            return false;
    }
  }
  checkout() {
    this.checkValidations();
    let username = this.$route.query.snbuser;
    let checkOutData = {
      quoteId: this.quoteID,
      invoiceNo: this.additionalInputs.poNumber,
      poContactName: this.additionalInputs.poContactName,
      poContactPhone: this.additionalInputs.poContactPhone,
      poContactEmail: this.additionalInputs.poContactEmail,
      resellerName: this.additionalInputs.resellerName,
      resellerContactName: this.additionalInputs.resellerContactName,
      resellerPhoneNO: this.additionalInputs.resellerPhoneNO,
      check1: this.additionalInputs.check1,
      check2: this.additionalInputs.check2,
      desc: this.quoteItems[0].ssipnDesc,
      fullName: this.quoteAddress.fullName,
      address1: this.quoteAddress.addressLine1,
      address2: this.quoteAddress.addressLine2,
      city: this.quoteAddress.city,
      state: this.quoteAddress.state ? this.quoteAddress.state : '',
      zipcode: this.quoteAddress.zipCode,
      emailAddress: this.quoteAddress.emailAddress,
      phone: this.quoteAddress.phoneNumber,
      purchaseOptionId: this.selectedPM,
      province: this.quoteAddress.province ? this.quoteAddress.province : '',
      country: this.quoteAddress.country,
      isSaveAddress: this.saveAddressForFuture,
      poContactCompany: this.additionalInputs.poContactCompany,
      poContactAddress1: this.additionalInputs.poContactAddress1,
      poContactAddress2: this.additionalInputs.poContactAddress2,
      poContactCity: this.additionalInputs.city,
      poContactPostalCode: this.additionalInputs.poContactPostalCode,
      poContactProvince: this.additionalInputs.poContactProvince,
      poContactState: this.additionalInputs.poContactState,
      poContactCountry: this.additionalInputs.poContactCountry,
    };
    const cartCount = this.quoteItems.length;
    this.$store
      .dispatch('SnbQuotesStoreModule/moveToBasket', checkOutData)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus == 'OK') {
          if (res.content.orderId) {
            this.$store.commit('CheckoutStoreModule/mutate', { property: 'orderId', with: res.content.orderId });
            this.$router.push('checkout/order_details');
            this.$emit('closeQuoteDetailsDialog');
          } else {
            if (res.msgCode == 'MSWAPP:VIEWBASKET') {
              this.$store.commit('mutate', { property: 'cartCount', with: cartCount });
              if (window.location.href.indexOf('/feature/') > -1) {
                this.$router.push({ path: `/m/feature/cart?snbuser=${username}` });
              } else {
                this.$router.push({ path: `/m/feature/cart` });
              }
              this.$emit('closeQuoteDetailsDialog');
            } else if (res.msgCode == "MSWAPP:CHECKOUTORDER") {
              setTimeout(
                () => {
                  this.$router.push('checkout/billing');
                  this.$emit('closeQuoteDetailsDialog');
                },
                2000
              );
            }
          }
          const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      });
  }

  exportTooltip(): TooltipDirValues {
    return {
      compact: true,
      enabled: this.enableTooltip,
      placement: 'bottom',
      content: this.$t('productslarge.export')
      .toString(),
      includePopperForHover: true,
    };
  }
  searchTooltip(): TooltipDirValues {
    return {
      compact: true,
      enabled: this.enableTooltip,
      placement: 'bottom',
      content: this.$t('profile.search')
      .toString(),
      includePopperForHover: true,
    };
  }
}
